import { Clock } from 'three';

/**
 * A requestAnimationFrame loop with a clamped delta time (so a paused/
 * backgrounded tab doesn't produce a huge physics step on resume).
 */
export class GameLoop {
  private readonly clock = new Clock();
  private running = false;
  private readonly maxDelta = 0.05;

  constructor(private readonly onFrame: (dt: number) => void) {}

  start(): void {
    if (this.running) return;
    this.running = true;
    this.clock.start();
    this.tick();
  }

  private tick = (): void => {
    if (!this.running) return;
    requestAnimationFrame(this.tick);
    const dt = Math.min(this.clock.getDelta(), this.maxDelta);
    this.onFrame(dt);
  };
}
